/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";

import { StoryCard } from "../basic/story-card.js";
import PropTypes from "prop-types";
import "./three-story-card.m.css";

function ThreeStoryCards(props) {
  const majorStoryCardConfig = {
    image: true,
    imageAspectRatio: [16, 9]
  };

  if (props.stories.length < 1) {
    return <div> </div>;
  }

  return (
    <div className="three-col__items component-wrapper " styleName="three-story-card">
      <div className="three-col__item" styleName="item">
        <StoryCard hideSectionName={true} story={props.stories[0]} config={majorStoryCardConfig} />
      </div>
      <div className="three-col__item" styleName="item">
        <StoryCard hideSectionName={true} story={props.stories[1]} config={majorStoryCardConfig} />
      </div>
      <div className="three-col__item" styleName="item">
        <StoryCard hideSectionName={true} story={props.stories[2]} config={majorStoryCardConfig} />
      </div>
    </div>
  );
}

ThreeStoryCards.propTypes = {
  stories: PropTypes.object
};

export { ThreeStoryCards };
